import React, { useState, useEffect } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API, } from 'aws-amplify';
import '../components/estilos.css';
import Moment from 'moment';
import { GetRecibaID, GetRecibaSeriales, GetRecibaSerialesID, GetRecibaSerialesIDMP, GetRecibaSerialesMP, GetUbicacion, GetUsuarios } from '../components/queries/Queries';
import { createICuarentena, createRecuperacion, createUbicacion, updateICuarentena, updateReciba, updateRecibaSeriales, updateRecibaSerialesMP, updateUbicacion } from '../graphql/mutations';
import { cambioUbicacionSeriales } from '../components/queries/DCUbicaciones';
import { generateClient } from "aws-amplify/api";

const API = generateClient();
const initialfFormState = { formType: 'Cuarentena' }
export default function useCuarentena() {
    //Declaración de variables    
    const [reciba, setReciba] = useState([]);
    const [recibaSinFiltro, setRecibaSinFiltro] = useState([]);
    const [mRecibas, setMRecibas] = useState([]);
    const [formState, updateFormState] = useState(initialfFormState);
    const [estadoReciba, setEstadoReciba] = useState("todos");
    const [search, setSearch] = useState("");
    const [searchBy, setSearchBy] = useState("cliente");
    const [totalRecords, setTotalRecords] = useState(0);
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const ppalmacen = window.$Cuarentena ? window.$Cuarentena : false;
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [vistaUltimoAP, setVistaUltimoAP] = useState(false);
    const onDismiss = () => setAVisible(false);
    const [inputList, setInputList] = useState([]);
    const [activeTab, setActiveTab] = useState('1');
    const [packings, setPackings] = useState(1);
    const [modal2, setModal2] = useState(false);
    const [pInspeccion, setPInspeccion] = useState([]);
    const [nombreUsuario, setNombreUsuario] = useState("");

    Moment.locale('en');
    var now = new Date();

    const toggle1 = tab => {
        if (activeTab !== tab) setActiveTab(tab);
        if (tab > 1) setAVisible(false);
    }
    const toggle2 = () => setModal2(!modal2);

    // current page
    const [currentPage, setCurrentPage] = useState(1);

    // total records per page to display
    const recordPerPage = 20;

    // range of pages in paginator
    const pageRange = 5;

    // handle change event
    function handlePageChange(pageNumber) {
        setAVisible(false);
        setCargando(false);
        setCurrentPage(pageNumber);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, pageNumber, vistaUltimoAP);
    }

    async function busqueda(recibasinf, estadoReciba, searchb, search, currentPage, vistaUAP) {
        /*setMensajeAlert(Moment(search).format("DD/MM/YYYY"));
        setColor("warning");
        setAVisible(true);*/
        var pag = 1;
        var bandera = 1;
        //Se revisa el tipo de vista que se requiere de los datos
        var recibaFromAPI = vistaUAP === true ? recibasinf.sort((a, b) =>
            a.numero < b.numero ? 1 : a.numero > b.numero ? -1 : 0) :
            recibasinf.sort((a, b) => a.numero > b.numero ? 1 : a.numero < b.numero ? -1 : 0);

        //Filtrado de datos por la búsqueda y el estado de reciba
        recibaFromAPI = recibaFromAPI.filter(reciba =>
            estadoReciba === "todos" ? reciba.status === reciba.status : reciba.status === estadoReciba).filter(reciba =>
                searchb === "numero de parte" ? reciba.numerodeParte.toLowerCase().includes(search.toLowerCase()) :
                    searchb === "cliente" ? reciba.cliente.toLowerCase().includes(search.toLowerCase()) :
                        searchb === "id de reciba" ? reciba.numero.toLowerCase().includes(search.toLowerCase()) :
                            searchb === "serial" ? reciba.serial.toLowerCase().includes(search.toLowerCase()) :
                                searchb === "serial BTI" ? reciba.serialRecibaBTI ? reciba.serialRecibaBTI.toLowerCase().includes(
                                    search.toLowerCase()) : "".includes(search.toLowerCase()) :
                                    searchb === "paking" ? reciba.packing.toLowerCase().includes(search.toLowerCase()) :
                                        searchb === 'lote' ? reciba.lote.toLowerCase().includes(search.toLowerCase()) :
                                            searchb === 'NCProduccion' ? (reciba.piezasCtnaPintadas ? reciba.piezasCtnaPintadas : 0) > 0 :
                                                searchb === 'NCIncoming' ? ((reciba.piezasenCuarentena ? reciba.piezasenCuarentena : 0) - (reciba.piezasCtnaPintadas ? reciba.piezasCtnaPintadas : 0)) > 0 :
                                                    reciba.fechayHoraDeReciba.includes(Moment(search).format("DD/MM/YYYY")));


        await Promise.all(recibaFromAPI.map(async reciba => {
            //producto.indexnum=bandera;
            reciba.indexpag = pag;
            bandera++;
            if (bandera > recordPerPage) {
                bandera = 1;
                pag++;
            }

            return reciba;
        }))

        const lengthreciba = recibaFromAPI.length;
        if (lengthreciba <= 0)
            setCurrentPage(1);

        setReciba(recibaFromAPI.filter(reciba => reciba.indexpag === currentPage));
        setTotalRecords(lengthreciba);

        if (currentPage > 1 && lengthreciba > 0) {
            const prepaginas = parseInt(lengthreciba / recordPerPage);
            const paginas = prepaginas * recordPerPage < lengthreciba ? prepaginas + 1 : prepaginas;
            if (currentPage > paginas) {
                setCurrentPage(paginas);
                const recibaFromAPIp = recibaFromAPI.filter(reciba =>
                    reciba.indexpag === paginas);
                setReciba(recibaFromAPIp);
            }
        }
    }

    //Método useEffect
    useEffect(() => {
        fetchCuarentena();
        fetchUsuario();
    }, []);

    //Obtiene el nombre de usuario del usuario logueado
    async function fetchUsuario() {
        //Filtro por planeación activa        
        let filter = {
            usuario: {
                eq: userName
            }
        }
        //Se obtienen los datos del usuario
        const apiData = await GetUsuarios(filter);
        //Se filtran los datos por orden
        const dataFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        setNombreUsuario(dataFromAPI[0].nombreCompleto);
    }
    //Ob
    //Obtiene los datos guardados de Almacen
    async function fetchCuarentena() {
        setCargando(true);
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            },
            {
                piezasenCuarentena: {
                    gt: 0
                }
            }
            ]
        }


        //Obtiene los datos de los seriales, filtrados por piezasenAlmacen
        const apiData = await GetRecibaSerialesMP(filter);

        const recibaFromAPI = apiData.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);

        setRecibaSinFiltro(recibaFromAPI);
        busqueda(recibaFromAPI, estadoReciba, searchBy, search, currentPage, vistaUltimoAP);
        //busqueda(recibaFromAPI, estadoReciba, searchBy, search, currentPage, vistaUltimoAP, vistaNumeroParte, recordPerPage);
        setCargando(false);
    }
    function palmacen() {
        setInputList([]);
        setMRecibas({ ...reciba });
        updateFormState(() => ({ ...formState, formType: "Cuarentena" }));
    }

    function buscarpor(e) {
        setAVisible(false);
        setSearchBy(e.target.value);
        if ((search && e.target.value !== "fecha") || e.target.value === "NCProduccion" || e.target.value === "NCIncoming")
            busqueda(recibaSinFiltro, estadoReciba, e.target.value, search, currentPage, vistaUltimoAP);
    }
    function onSearch(e) {
        setAVisible(false);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, vistaUltimoAP);
    }
    function onSearchFecha(e) {
        setAVisible(false);
        setSearch(e.target.value);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, e.target.value, currentPage, vistaUltimoAP);
    }
    //Ordena los  packings de la lista de recibas
    function obtenerPacking(list) {
        var listPacking = [];
        var packings = "";
        var packingsn = 1;

        list.map((packing, i) => {
            if (packings !== packing.packing) {
                listPacking.push({ packing: packing.packing, packingindex: packingsn });
                packingsn = packingsn + 1;
                packings = packing.packing;
            }
        });
        setPackings(packingsn);
        return listPacking
    }
    //Ordena los seriales de la lista de recibas tomando en cuenta los packings
    function obtenerSerialesMostrar(list, packings, idSerial) {
        var seriallist = [];
        var sombra = true;
        packings.map((packing, i) => {
            sombra = !sombra;
            list.map((serial) => {
                if (serial.packing === packing.packing) {
                    serial.sombreado = sombra;
                    seriallist.push(serial);
                    serial.locacionOriginal = serial.locacion;
                }
                if (serial.id === idSerial)
                    serial.sombreado = true;
                else
                    serial.sombreado = false;
            });
        });
        return seriallist
    }

    //Obtiene los datos guardados de Reciba por ID
    async function fetchRecibaporID(recibaID) {
        //Se obtiene la reciba por ID
        const recibaFromAPI = await GetRecibaID(recibaID);
        return recibaFromAPI;
    }

    //Obtiene los datos guardados de Reciba por ID
    async function fetchRecibaSerialporID(recibaID) {
        let filter = {
            recibaID: {
                eq: recibaID
            },
            activo: {
                eq: true
            }
        }
        //Obteniendo los datos de los seriales/contenedores        
        const dataSeriales = await GetRecibaSeriales(filter);
        const recibaSerialesFromAPI = dataSeriales.sort((a, b) =>
            a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0)
        //setRecibaSerialesSinFiltro(recibaSerialesFromAPI);
        return recibaSerialesFromAPI;
    }

    async function cliclMostrar(reciba) {
        setCargando(true);
        setAVisible(false);
        const listas = await fetchRecibaporID(reciba.recibaID);
        setMRecibas({ ...listas, Reg_Mod_Usuario: userName });
        const seriales = await fetchRecibaSerialporID(reciba.recibaID);
        //await fetchUltimaUbicacion(reciba.recibaID);
        const packings = obtenerPacking(seriales.sort((a, b) =>
            a.packingindex > b.packingindex ? 1 : a.packingindex < b.packingindex ? -1 : 0));
        setInputList(obtenerSerialesMostrar(seriales.sort((a, b) =>
            a.numerodeParte > b.numerodeParte ? 1 : a.numerodeParte < b.numerodeParte ? -1 : 0), packings, reciba.id));
        updateFormState(() => ({ ...formState, formType: "Detalle Reciba " + reciba.numero }));
        setCargando(false);
    }
    function obtenerUltimaUbicaciont(ubicacion) {
        var uUbicacion = "";
        var uLocacion = "";
        var uCantidad = "";
        var uEspacio = "";
        return <>
            <Table className="bordersubtabla">
                <Thead>
                    <Tr>
                        <Th className="subtablah bordersubtabla">Ubic.</Th>
                        <Th className="subtablah bordersubtabla">Loc.</Th>
                        <Th className="subtablah bordersubtabla">Pzs.</Th>
                        <Th className="subtablah bordersubtabla">Esp.</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {ubicacion && (
                        <>
                            {ubicacion.map(x => (
                                uUbicacion = x.substr(1, x.search(',') - 1).replace('ubicacion=', ''),
                                uLocacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', ''),
                                uCantidad = x.substr(x.search('cantidad=') + 8, x.length).substr(1, x.substr(x.search('cantidad=') + 8, x.length).search(',') - 1).replace('cantidad=', ''),
                                uEspacio = x.substr(x.search('espacio=') + 7, x.length).substr(1, x.substr(x.search('espacio=') + 7, x.length).search('}') - 1).replace('espacio=', ''),
                                <Tr>
                                    <Td className="bordersubtabla">{uUbicacion}</Td>
                                    <Td className="bordersubtabla">{uLocacion}</Td>
                                    <Td className={uLocacion ? "bordersubtabla" : "margintopmobil20px bordersubtabla"}>{uCantidad}</Td>
                                    <Td className="bordersubtabla">{uEspacio}</Td>
                                </Tr>

                            ))}
                        </>)}
                </Tbody>
            </Table>
        </>
    }
    function obtenerUltimaUbicacionA(ubicacion) {
        var aUbicaciones = [];
        ubicacion.map((x) => {
            const uUbicacion = x.substr(1, x.search(',') - 1).replace('ubicacion=', '');
            const uLocacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', '');
            const uCantidad = x.substr(x.search('cantidad=') + 8, x.length).substr(1, x.substr(x.search('cantidad=') + 8, x.length).search(',') - 1).replace('cantidad=', '');
            const uEspacio = x.substr(x.search('espacio=') + 7, x.length).substr(1, x.substr(x.search('espacio=') + 7, x.length).search('}') - 1).replace('espacio=', '');
            aUbicaciones.push({ ubicacion: uUbicacion, locacion: uLocacion, cantidad: uCantidad, espacio: uEspacio })

        })
        return aUbicaciones;
    }
    //Indicador de vista del más actual al más antigüo
    function onChangescheckVUAP(e) {
        setVistaUltimoAP(e.target.checked);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage, e.target.checked);
    }
    function clicInspeccion(lista) {
        setPInspeccion(() => ({ ...lista, ["piezasEnRecuperando"]: "" }));
        setModal2(!modal2);
    };
    function onChangesCantidad(e) {
        e.persist()
        const re = /^[0-9\.]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setPInspeccion(() => ({
                ...pInspeccion, [e.target.name]: e.target.value
            }));
        }
    }
    function onChanges(e) {
        e.persist()
        setPInspeccion(() => ({
            ...pInspeccion, [e.target.name]: e.target.value
        }));
    }
    async function aceptarInspeccion() {
        setAVisible(false);
        setCargando(true);
        setModal2(!modal2);
        try {//Revisa que no falten datos
            setMensajeAlert("Iniciando la validaciones");
            const piezasenAlmacen = parseInt(pInspeccion.CAprobado ? pInspeccion.CAprobado : 0);
            const piezasAEmbarcar = parseInt(pInspeccion.CNAprobado ? pInspeccion.CNAprobado : 0);
            const PiezasCtnaRecuperacion = parseInt(pInspeccion.piezasEnRecuperando ? pInspeccion.piezasEnRecuperando : 0);
            const piezasTotales = (piezasenAlmacen +
                (pInspeccion.piezasCtnaNAEmbarcar ? pInspeccion.piezasCtnaNAEmbarcar : 0) + piezasAEmbarcar +
                (pInspeccion.PiezasCtnaRecuperacion ? pInspeccion.PiezasCtnaRecuperacion : 0) + PiezasCtnaRecuperacion) +
                parseInt(pInspeccion.piezasCtnaPintadas ? pInspeccion.piezasCtnaPintadas : 0);

            var mensaje = "";
            if (parseInt(piezasTotales) > parseInt(pInspeccion.piezasenCuarentena))
                mensaje = "La suma total de las piezas a aprobadas para ir a almacén, más las que se embarcarán para regresar al cliente " +
                    ", más las piezas que se mandarán a recuperación no debe ser mayor a la cantidad en cuarentena: " + pInspeccion.piezasenCuarentena + ".";
            /*setMensajeAlert("Piezas a registrar en almacén: " + piezasenAlmacen + 
            "Piezas en almacén: "+ pInspeccion.piezasenAlmacen+ " Piezas a registrar a embarcar: "+ piezasAEmbarcar+
            "Piezas a embarcar: " + pInspeccion.piezasCtnaNAEmbarcar + "Piezas a registrar en recuperación: "+ 
            PiezasCtnaRecuperacion + " piezas en cuarentena: "+ pInspeccion.PiezasCtnaRecuperacion+ 
            " piezas pintadas en cuarentena: "+  pInspeccion.piezasCtnaPintadas+
             "La suma total de las piezas " +  piezasTotales + " Cantidad en cuarentena: " + pInspeccion.piezasenCuarentena + ".");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            return*/
            if (!pInspeccion.CNAprobado && !pInspeccion.CAprobado && !pInspeccion.piezasEnRecuperando)
                mensaje = mensaje + "\nSe debe ingresar una cantidad de piezas a embarcar, para almacén o para el área de recuperación.";


            if (pInspeccion.piezasEnRecuperando && ((!pInspeccion.defecto || !pInspeccion.mRecuperacion) ||
                (pInspeccion.defecto === "Otro" && !pInspeccion.otroDefecto) || (pInspeccion.mRecuperacion === "Otro" && !pInspeccion.otroMRecuperacion)))
                mensaje = mensaje + "\nFaltan datos, los datos marcados con asterísco son obligatorios";
            setMensajeAlert("Terminando validaciones");
            if (mensaje !== "") {
                setMensajeAlert(mensaje);
                setColor("warning");
                setCargando(false);
                setAVisible(true);
            } else {
                setMensajeAlert("Revisando concurrencia, id: " + pInspeccion.id);
                var pConcurrencia = false;
                //Se obtienen los datos de la Reciba por id para revisar la concurrencia                
                const dataFromAPI = await GetRecibaSerialesIDMP(pInspeccion.id);
                setMensajeAlert("Datos obtenidos");
                if (!dataFromAPI.id) {
                    setMensajeAlert("Datos obtenidos 1");
                    pConcurrencia = true;
                    setMensajeAlert("Menor que 1");
                } else {
                    setMensajeAlert("Datos obtenidos 2");
                    if (dataFromAPI.updatedAt !== pInspeccion.updatedAt) {
                        pConcurrencia = true;
                        setMensajeAlert("Diferente UpdateAt, Update tabla: " + dataFromAPI.updatedAt + " Update registro leido: " + pInspeccion.updatedAt);
                    }
                }
                //Si no existe concurrencia, se continua con la operación                
                if (pConcurrencia === false) {
                    setMensajeAlert("No hay concurrencia");
                    //Datos requeridos para registrar la operación
                    const fechaSalida = Moment(new Date()).format("YYYY-MM-DD");
                    const horaSalida = Moment(new Date()).format("HH:mm");
                    //Se revisa si las piezas que se mandarán a almacén son todas las piezas recibidas
                    //Si existen piezas en almacén
                    setMensajeAlert("Fechas establecidas");
                    const rInspeccion = await GetRecibaSerialesID(pInspeccion.recibaSerialID);
                    if (piezasenAlmacen > 0) {
                        setMensajeAlert("Iniciando proceso en almacén");
                        //Se indican las piezas que se mandarán a almacén.
                        rInspeccion.piezasenAlmacen = rInspeccion.piezasenAlmacen ? rInspeccion.piezasenAlmacen + piezasenAlmacen : piezasenAlmacen;
                        rInspeccion.piezasenCuarentena = rInspeccion.piezasenCuarentena - piezasenAlmacen;
                        if (piezasenAlmacen === rInspeccion.cantidadRecibida) {
                            //Si es así, se revisa el estatus de la reciba por id
                            setMensajeAlert("Obteniendo los datos de la reciba por id: " + rInspeccion.recibaID);
                            const recibaOriginal = await GetRecibaID(rInspeccion.recibaID)
                            setMensajeAlert("Datos obtenidos");
                            //Si el estatus es Parcialmente Rechazado, se revisa el estatus del resto de los seriales de la reciba.
                            if (recibaOriginal.status === "Parcialmente Rechazado") {
                                //Se obtienen los seriales de la reciba correspondiente que estén activos y en la planta
                                const recibasEstatus = await GetRecibaSerialesMP({
                                    and: [{ activo: { eq: true } },
                                    { recibaID: { eq: pInspeccion.recibaID } }]
                                })
                                //Si se obtuvieron registros
                                if (recibasEstatus.length > 0) {
                                    //Se filtran los registros con estatus de rechazado
                                    const recibaEF = recibasEstatus.filter(reciba => reciba.status === "Rechazado");
                                    //Si existe solo un registro con estatus de rechazado
                                    if (recibaEF.length === 1) {
                                        //Si el registro con estatus de rechazado es con el que estamos trabajando.
                                        if (recibaEF[0].id === pInspeccion.id) {
                                            //Se actualiza el registro de reciba.
                                            delete recibaOriginal.updatedAt;
                                            delete recibaOriginal.__typename;
                                            delete recibaOriginal.createdAt;
                                            recibaOriginal.Reg_Mod_Usuario = userName;
                                            recibaOriginal.status = "Aceptado";
                                            setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaOriginal));
                                            await API.graphql({ query: updateReciba, variables: { input: recibaOriginal } });
                                        }
                                    }
                                }
                            }
                            pInspeccion.status = "Aceptado";
                        }
                        //Se cambia la ubicación del material que corresponde a almacén
                        var auxUltimaUbicacion = [];
                        const loacionAnterior = "";
                        const ubicacionAnterior = "Cuarentena";
                        const loacionPiezas = "";
                        const ubicacionPiezas = "Almacén";
                        const cantidadPiezas = piezasenAlmacen;
                        var cambioUbicacionAux = [];
                        setMensajeAlert("Antes de obtener los datos del cambio de ubicación");
                        cambioUbicacionAux = await cambioUbicacionSeriales(
                            rInspeccion,
                            ubicacionAnterior,
                            loacionAnterior,
                            ubicacionPiezas,
                            loacionPiezas,
                            cantidadPiezas);
                        setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(cambioUbicacionAux));
                        if (cambioUbicacionAux.mensaje != "") {
                            setMensajeAlert(cambioUbicacionAux.mensaje);
                            setColor(cambioUbicacionAux.color);
                            setCargando(false);
                            setAVisible(true);
                            return;
                        } else {
                            rInspeccion.ultimaUbicacion = cambioUbicacionAux.sUltimaU;
                            rInspeccion.rubicaciones = cambioUbicacionAux.sUbicaciones
                            setMensajeAlert("Ubicaciones agrupadas");
                        }
                    }
                    setMensajeAlert("Terminó el proceso en almacén");
                    //Si existen registros que van para embarcar
                    if (piezasAEmbarcar > 0) {
                        setMensajeAlert("Iniciando proceso en Embarcar");
                        rInspeccion.piezasCtnaNRecuperadas = rInspeccion.piezasCtnaNRecuperadas ? rInspeccion.piezasCtnaNRecuperadas + piezasAEmbarcar : piezasAEmbarcar;
                        rInspeccion.piezasCtnaNAEmbarcar = rInspeccion.piezasCtnaNAEmbarcar ? rInspeccion.piezasCtnaNAEmbarcar + piezasAEmbarcar : piezasAEmbarcar;

                    }
                    //Sí hay material para recuperación, se registra en la tabla de recuperación.
                    if (PiezasCtnaRecuperacion > 0) {
                        setMensajeAlert("Iniciando proceso en Recuperación");
                        //Datos para actualizar en recibaSeriales
                        rInspeccion.piezasTRecuperacion = rInspeccion.piezasTRecuperacion ? rInspeccion.piezasTRecuperacion + PiezasCtnaRecuperacion : PiezasCtnaRecuperacion;
                        rInspeccion.PiezasCtnaRecuperacion = rInspeccion.PiezasCtnaRecuperacion ? rInspeccion.PiezasCtnaRecuperacion + PiezasCtnaRecuperacion : PiezasCtnaRecuperacion;
                        //Datos para registrar los registros en recuperación

                        const Recuperacion = {};
                        Recuperacion.recibaSerialID = rInspeccion.id;
                        Recuperacion.recibaSerialMPID = pInspeccion.id;
                        Recuperacion.serialRecibaBTI = rInspeccion.serialRecibaBTI;
                        Recuperacion.clienteID = rInspeccion.clienteID;
                        Recuperacion.cliente = rInspeccion.cliente;
                        Recuperacion.productoID = rInspeccion.productoID;
                        Recuperacion.numerodeParte = rInspeccion.numerodeParte;
                        Recuperacion.descripcion = rInspeccion.descripcion;
                        Recuperacion.serial = rInspeccion.serial;
                        Recuperacion.cantidad = PiezasCtnaRecuperacion;
                        Recuperacion.ingresadoPorArea = "Cuarentena";
                        Recuperacion.UbicacionDeIngreso = "Cuarentena";
                        Recuperacion.ingresadoPorUsuario = nombreUsuario;
                        Recuperacion.defecto = pInspeccion.defecto;
                        Recuperacion.otroDefecto = pInspeccion.otroDefecto;
                        Recuperacion.mRecuperacion = pInspeccion.mRecuperacion;
                        Recuperacion.otroMRecuperacion = pInspeccion.otroMRecuperacion;
                        Recuperacion.comentariosInspeccion = pInspeccion.comentariosdecuarentena;
                        Recuperacion.activo = true;
                        Recuperacion.fechaIngreso = fechaSalida;
                        Recuperacion.horaIngreso = horaSalida;
                        Recuperacion.Reg_Ins_Usuario = userName;
                        setMensajeAlert("Operación errónea; Problemas al guardar los datos del material en recuperación" + JSON.stringify(Recuperacion));
                        await API.graphql({ query: createRecuperacion, variables: { input: Recuperacion } });
                    }
                    //Se preparan los datos para su registro en ICuarentena
                    rInspeccion.UltimaInspeccionCuarentena = rInspeccion.UltimaInspeccionCuarentena ? rInspeccion.UltimaInspeccionCuarentena + 1 : 1;
                    rInspeccion.comentariosdecuarentena = pInspeccion.comentariosdecuarentena;

                    const ICuarentena = {};
                    ICuarentena.recibaSerialID = rInspeccion.id;
                    ICuarentena.recibaSerialMPID = pInspeccion.id;
                    ICuarentena.lote = rInspeccion.lote;
                    ICuarentena.serial = rInspeccion.serial;
                    ICuarentena.serialRecibaBTI = rInspeccion.serialRecibaBTI;
                    ICuarentena.piezasAEmbarcar = piezasAEmbarcar;
                    ICuarentena.piezasenAlmacen = piezasenAlmacen;
                    ICuarentena.piezasenCuarentena = rInspeccion.piezasenCuarentena;
                    ICuarentena.piezasaRecuperar = PiezasCtnaRecuperacion;
                    ICuarentena.inspeccion = rInspeccion.UltimaInspeccionCuarentena;
                    ICuarentena.defecto = pInspeccion.defecto;
                    ICuarentena.otroDefecto = pInspeccion.otroDefecto;
                    ICuarentena.mRecuperacion = pInspeccion.mRecuperacion;
                    ICuarentena.otroMRecuperacion = pInspeccion.otroMRecuperacion;
                    ICuarentena.comentarios = rInspeccion.comentariosdecuarentena;
                    ICuarentena.activo = true;
                    ICuarentena.fechaIngreso = fechaSalida;
                    ICuarentena.horaIngreso = horaSalida;
                    ICuarentena.Reg_Ins_Usuario = userName;

                    //Se actualizan los datos en Reciba Seriales
                    setMensajeAlert("Iniciando proceso de guardado de datos en reciba serial");
                    delete rInspeccion.createdAt;
                    delete rInspeccion.updatedAt;
                    delete rInspeccion.__typename;
                    rInspeccion.Reg_Mod_Usuario = userName;
                    //Se actualiza el estatus en reciba seriales
                    setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(rInspeccion));
                    let upRecibaS = await API.graphql({ query: updateRecibaSeriales, variables: { input: rInspeccion } });

                    //Se actualizan los datos en recibaSerialesMP
                    const recibaSerialMPID = rInspeccion.recibaSerialMPID;
                    if (rInspeccion.recibaSerialMPID) {
                        delete rInspeccion.recibaSerialMPID;
                        setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(rInspeccion));
                        await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...rInspeccion, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });
                    }

                    //Se registran los datos en ICuarentena
                    setMensajeAlert("Operación errónea; Problemas al guardar los datos de la inspección" + JSON.stringify(ICuarentena));
                    await API.graphql({ query: createICuarentena, variables: { input: ICuarentena } });


                    setMensajeAlert("Operación exitosa"); //, piezas totales: " + piezasTotales + ", piezas en pintado: " + pInspeccion.piezasenPintado
                    setColor("primary");
                    setCargando(false);
                    setAVisible(true);
                    fetchCuarentena();

                } else { //Si  hay concurrencia se tienen que actualizar los datos
                    window.scrollTo(0, 0);
                    setMensajeAlert("No fue posible realizar la operación: existe concurrencia, favor de recargar los datos y " +
                        " volver a intentarlo");
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    fetchCuarentena();
                }
            }
        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas");
            setColor("warning");
            setCargando(false);
            setAVisible(true);
        }

    };
    return {
        ppalmacen,
        formType,
        color,
        aVisible,
        mensajeAlert,
        cargando,
        activeTab,
        searchBy,
        search,
        reciba,
        currentPage,
        recordPerPage,
        totalRecords,
        pageRange,
        mRecibas,
        inputList,
        modal2,
        pInspeccion,
        clicInspeccion,
        onChangesCantidad,
        onChanges,
        aceptarInspeccion,
        onDismiss,
        palmacen,
        toggle1,
        toggle2,
        buscarpor,
        setSearch,
        onSearchFecha,
        handlePageChange,
        onSearch,
        onChangescheckVUAP,
        fetchCuarentena,
        obtenerUltimaUbicaciont,
        obtenerUltimaUbicacionA,
        cliclMostrar
    }
}